import { AtSignIcon } from "@/components/Icons/AtSignIcon";
import { PhoneIcon } from "@/components/Icons/PhoneIcon";
import { RichTextView } from "@/components/RichTextView/RichTextView";
import { useTranslation } from "@/translations";
import { RuntimeColorContent } from "@/ui-adapters/RuntimeColorBadge";

import { AppHeader } from "./AppCommon";
import { PhoneInner } from "./PhoneInner";

interface AppServicePartnerDetailsViewProps {
  name: string;
  description: string;
  slogan?: string;
  headerImage?: string;
  profileImage?: string;
  email?: string;
  phoneNumber?: string;
  projectTintColor: string;
}
export function AppServicePartnerDetailsView({
  name,
  slogan,
  description,
  headerImage,
  profileImage,
  email,
  phoneNumber,
  projectTintColor,
}: AppServicePartnerDetailsViewProps): React.ReactNode {
  const { t } = useTranslation();
  const tintColor = projectTintColor || "#23175A";

  return (
    <PhoneInner>
      <AppHeader
        bgImage={headerImage}
        profileImage={profileImage ? <img className="size-full object-cover" src={profileImage} alt="" /> : null}
      />
      <article className="relative bg-background-default p-space-sm">
        <div className="float-right mr-space-xl h-icon-control w-thumbnail-prominent" />

        <header
          // oxlint-disable-next-line tailwindcss/no-conflicting-classes -- TODO: `flex` cancels line-clamp-3 (both set display)
          className="line-clamp-3 flex flex-col gap-space-xs wrap-break-word"
        >
          <span className="text-overline-emphasis">{name}</span>
          <span className="text-overline text-text-secondary">{slogan}</span>
        </header>

        <address className="my-space-sm flex items-center justify-end gap-space-sm bg-background-default">
          {phoneNumber && (
            <span className="flex justify-center rounded-full bg-background-secondary p-space-sm text-center">
              <RuntimeColorContent color={tintColor}>
                <PhoneIcon size={20} />
              </RuntimeColorContent>
            </span>
          )}
          {email && (
            <span className="flex justify-center rounded-full bg-background-secondary p-space-sm text-center">
              <RuntimeColorContent color={tintColor}>
                <AtSignIcon size={20} />
              </RuntimeColorContent>
            </span>
          )}
        </address>
      </article>
      <section className="mt-space-md bg-background-default px-space-md pt-space-sm pb-space-md break-all whitespace-pre-line">
        <RichTextView title="description preview">{description || "-"}</RichTextView>
      </section>
      {phoneNumber || email ? (
        <dl className="my-space-md">
          {phoneNumber ? (
            <div className="flex flex-col items-start justify-between gap-space-xs border-b border-border-default bg-background-default p-space-sm">
              <dt className="truncate text-overline text-text-secondary">{t("model.service.phone-number")}</dt>
              <dd className="text-overline wrap-break-word text-text-primary">{phoneNumber || "-"}</dd>
            </div>
          ) : null}
          {email ? (
            <div className="flex flex-col items-start justify-between gap-space-xs bg-background-default p-space-sm">
              <dt className="truncate text-overline text-text-secondary">{t("model.service.email")}</dt>
              <dd className="text-overline wrap-break-word text-text-primary">{email || "-"}</dd>
            </div>
          ) : null}
        </dl>
      ) : null}
    </PhoneInner>
  );
}
